import React from 'react';
import { Box } from "lucide-react";

export const EmptyState = () => (
  <div className="flex flex-col items-center justify-center h-[400px] text-center">
    <Box className="h-12 w-12 text-gray-400 mb-4" />
    <h3 className="text-lg font-medium text-gray-900 mb-2">No Subjects</h3>
    <p className="text-sm text-gray-500 mb-4">Get started by creating your first subject</p>
  </div>
); 